import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// #88 Phase 3 — under Electron the SPA loads via `file://` and
// `window.location.pathname` is the absolute filesystem path to
// index.html, which BrowserRouter tries to match as a route (and never
// finds), silently rendering nothing. HashRouter puts the route in the
// URL fragment (`#/projects/…`) which is client-only, so `file://`
// works. The build toggle keys off `VEODIAGRAM_TARGET=desktop` at
// build time — matches the vite config's `base` toggle so a single
// env var configures both.
const isDesktopBuild =
  typeof import.meta !== 'undefined' && import.meta.env?.VITE_TARGET === 'desktop';
const Router = isDesktopBuild ? HashRouter : BrowserRouter;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);
